import * as React from 'react';
import {
  STEP_PASSWORD,
  STEP_TOTP_CONFIG,
  STEP_TOTP_SN_WARNING,
  STEP_USERNAME,
} from '../providers/auth/context';
import { useAuthData } from '../providers/auth/hooks';
import LoginStepPassword from './step-password';
import LoginStepTotpConfig from './step-totp-config';
import LoginStepTotpSNWarning from './step-totp-sn-warning';
import LoginStepUsername from './step-username';

const LoginFormWizard: React.FC = () => {
  const { currentStep } = useAuthData();

  switch (currentStep) {
    default:
    case STEP_USERNAME:
      return <LoginStepUsername />;

    case STEP_PASSWORD:
      return <LoginStepPassword />;

    case STEP_TOTP_CONFIG:
      return <LoginStepTotpConfig />;

    case STEP_TOTP_SN_WARNING:
      return <LoginStepTotpSNWarning />;
  }
};

export default LoginFormWizard;
